export default __webpack_public_path__ + "static/media/epilogue_silhouette.27324246.png";